import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as styles from './LinkButton.css';

interface ILinkButtonProps {
  children: React.ReactNode;
  marginTop?: number;
  href?: string;
  target?: '_self' | '_blank';
  title?: string;
  rel?: string;
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const LinkButton = ({ marginTop, href, target, title, rel, children, onClick }: ILinkButtonProps) => {
  return (
    <a
      href={href}
      target={target}
      title={title}
      rel={rel}
      onClick={onClick}
      {...mergeStyles(styles['link'], { marginTop: `${marginTop}px` })}
    >
      {children}
    </a>
  );
};
